module.exports = __webpack_public_path__ + "img/c03_buildingstartechfurorceltica_Normal_ua.0e3f76a1.webp";